export default {
  active: {
    text: 'Actualmente tu servicio {msisdn} está afiliado al Débito Automático Mensual.',
    date: 'El pago de tu factura se realizará a partir de la fecha {date}.',
    confirmedTitle: '¡Correo enviado!',
    confirmedText: 'Por favor, revisa el correo electrónico asociado a tu Débito Automático Mensual para realizar cambios en tus datos registrados.'
  },
  cancellation: {
    text: 'Hemos recibido una solicitud para cancelar el Débito Automático Mensual de tu servicio {msisdn} asociado a tu tarjeta con terminación {card}.',
    instruction: 'Para cancelar el Débito Automático Mensual de tu factura da click en confirmar.',
    confirmedTitle: 'Débito Automático Mensual Cancelado',
    confirmedText: 'Se ha dado de baja la tarjeta afiliada a Débito Automático Mensual de tu factura.'
  },
  affiliationResult: {
    Success: {
      title: '¡Felicidades!',
      description: 'Se ha activado exitosamente el Débito Automático Mensual de la factura de tu servicio {serviceId} a tu tarjeta con terminación {card}.'
    },
    IsConfirmed: {
      title: 'Afiliación de cobro automático',
      description: 'Este link ya ha sido confirmado.'
    },
    Expired: {
      title: 'Afiliación de cobro automático',
      description: 'Este link ya ha expirado.'
    },
    NotFound: {
      title: 'Afiliación de cobro automático',
      description: 'Este link no es válido'
    }
  },
  updateCard: {
    title: '¡Cambio de tarjeta exitoso!',
    text: 'Se ha realizado el cambio de tarjeta afiliada a Débito Automático Mensual de tu factura.'
  },
  validateEmail: {
    title: 'Verifica tu dirección de correo electrónico',
    text: 'Para confirmar tu afiliación de Débito Automático Mensual, hemos enviado un código a {email}.'
  },
  emailChangeSuccess: {
    title: '¡Cambio exitoso!',
    subtitle: 'Tu correo se ha cambiado correctamente.',
    text: 'Recibirás un correo electrónico de confirmación del cambio del correo en un lapso no mayor a 24 horas.'
  }

};
